import { type UpdateHookResponse, mutationUpdate } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useExternalLinkCache } from './cache'
import { type ExternalLinkUpdateInput, type ExternalLinkUpdateSuccess, type ExternalLinkData } from '@terros/common'

export function useUpdateExternalLink(): UpdateHookResponse<ExternalLinkUpdateInput, ExternalLinkData> {
  const mutation = useTantalimMutation<ExternalLinkUpdateInput, ExternalLinkUpdateSuccess>({
    url: '/externalLink/update',
  })
  const cache = useExternalLinkCache()

  async function update(updateData: ExternalLinkUpdateInput): Promise<ExternalLinkData> {
    const output = await mutation.mutateAsync(updateData)
    cache.setItem(output.externalLink)
    return output.externalLink
  }

  return mutationUpdate(mutation, update)
}
